const teamConfigs = {
  "tools.team-config-editor.title.new": "Create Team Config",
  "tools.team-config-editor.title.edit": "Edit Team Config",
  "tools.team-config-editor.home-kit": "Home Kit",
  "tools.team-config-editor.away-kit": "Away Kit",
  "tools.team-config-editor.description": "Create or edit team configurations.",
  "tools.team-config-editor.is-global.description": "Public team configurations are available to all users.",
  "tools.kit-editor.title.new": 'Create Kit',
  "tools.kit-editor.title.edit": "Edit Kit",
};

const accountsAdmin = {
    'tools.account-browser.search': 'Search accounts...',
    'tools.account-browser.title': 'Account Browser',
    'tools.account-browser.no-results': 'No accounts found',
    'tools.account-editor.title.new': 'Create Account',
    'tools.account-editor.title.edit': 'Edit Account',
    'tools.account-editor.add_member.title': 'Add Member',
    'tools.account-editor.add_product.title': 'Add Product',
    'tools.account-editor.edit_product.title': 'Edit Product',
    'tools.account-editor.remove_product.confirmation': 'Are you sure you want to remove this product?',
    'tools.account-editor.edit_member.title': 'Edit Member Role',
    'tools.account-editor.remove_member.confirmation': 'Are you sure you want to remove this member?',
    'tools.account-editor.details': 'Details',
    'tools.account-editor.is_business': 'Business Account',
    'label.name': 'Name',
    'label.email': 'Email',
    'label.role': 'Role',
    'label.joined': 'Joined Date',
    'label.search_users': 'Search users by name or email',
    'label.seats': 'Number of Seats'
};

const memberAdmin = {
    'tools.member-browser.no-results': 'No members found',
    'tools.member-editor.title': 'Edit Member',
    'label.first_name': 'First Name',
    'label.last_name': 'Last Name',
    'label.last_active': 'Last Active',
    'label.account': 'Account',
    'label.description': 'Description',
    'label.active': 'Active',
    'label.authorizations': 'Authorizations',
    'label.add': 'Add'
};

export const tools = { 
    ...teamConfigs, 
    ...accountsAdmin,
    ...memberAdmin,

    // Team Migration Dialog
    'tools.team-migration.title': 'Team Migration',
    'tools.team-migration.select_account.description': 'Select an account to migrate this team to:',
    'tools.team-migration.select_account.or': '- OR -',
    'tools.team-migration.select_account.create_new': 'Create New Account',
    
    'tools.team-migration.select_owner.description': 'Select a team admin to be the account owner:',
    
    // Team Member Migration Dialog
    'tools.team-migration.members.title': 'Migrate Team Members',
    'tools.team-migration.members.description': 'Review and confirm member role assignments:',
    'tools.team-migration.members.potential_owner': 'Potential Owner',
    'tools.team-migration.members.already_member': 'Already a member',
    'tools.team-migration.members.will_be_added': 'Will be added',
    'tools.team-migration.members.will_be_owner': 'Will be assigned as owner',
    'tools.team-migration.members.needs_owner': 'This account requires an owner. The oldest admin will be automatically assigned as the account owner.',

    // Reverse Migration Dialog
    'tools.reverse-migration.title': 'Select Account',
    'tools.reverse-migration.description': 'Select which account to remove this team from:',
    'tools.reverse-migration.remove_members': 'Also remove team members from the account',

    // Migration Browser Labels
    'label.migrate': 'Migrate',
    'label.reverse': 'Reverse',
    'label.already_migrated': 'Already migrated',
    'label.next': 'Next',
    'label.include': 'Include',
    'label.id': 'ID',
    'label.team_role': 'Team Role',
    'label.account_role': 'Account Role',
    'label.group': 'Group',
    'label.accounts': 'Accounts',
    'label.filters': 'Filters',

    // Filter Labels
    'filters.has_club': 'Has Club',
    'filters.min_members': 'Minimum Members',
    'filters.has_group': 'Has Group',
    'filters.has_accounts': 'Account Status',
    'filters.has_business_account': 'Has Business Account',
    'filters.accounts.all': 'All Teams',
    'filters.accounts.with': 'With Accounts',
    'filters.accounts.without': 'Without Accounts',

    // Button Labels
    'button.reset': 'Reset',
    'button.apply': 'Apply'
};